import emptyFolder from '../../../../assets/images/empoty-file.svg';
import CreateDataForEmptySection from '../../../../components/shared/CreateDataForEmptySection';
const DataRoomPlaceholder = ({ isEditable, onAddFile, t }) => (
  <div className="col-xs-12">
    {isEditable ? (
      <CreateDataForEmptySection
        handler={onAddFile}
        text={t(`f:button.btnCreateDataRoom`)}
        mainText={t(`f:button.createDataRoom`)}
      />
    ) : (
      <div className="d-flex justify-content-center mt-100 mb-100">
        <img
          src={emptyFolder}
          alt="drag-drop"
          className="data-room__no-nodes"
        />
      </div>
    )}
  </div>
);
export default DataRoomPlaceholder;
